import { useEffect } from "react";

const BASE_TITLE = "Neeraj Battan & Associates";

export function SEO({ title, description, path = "/" }) {
  useEffect(() => {
    document.title = title ? `${title} | ${BASE_TITLE}` : `${BASE_TITLE} | Chartered Accountants in Kurukshetra, Haryana`;
    let meta = document.querySelector('meta[name="description"]');
    if (meta && description) meta.setAttribute("content", description);
    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute("href", `https://neerajbattanassociates.com${path}`);
  }, [title, description, path]);
  return null;
}
